
import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import PropTypes from 'prop-types';
import Snackbar from '../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import Grid from '@mui/material/Grid';
import Button from '@material-ui/core/Button';
// import FullScreenDialog from "./../../../PopUp/FullScreendialogs"
import FullScreenDialog from '../FullScreen'
import PopupCsardeposit from './SelARDepositUse';
import { genURL } from '../../../_getjson';
import CustomBackdrop from '../../../Components/CustomBackdrop/Barckdrop';
import axios from 'axios';
export default function Csardeposit(props) {
    const { parm, recheckeddata, from } = props
    const [listitem, setListitem] = useState([])
    const [color, setColor] = useState("warning");
    const [icon, setIcon] = useState(ErrorIcon);
    const [messagealert, setMessagealert] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [opensnackbar, setopensnackbar] = useState(false);
    const [openFullScreenDialog, setopenFullScreenDialog] = useState(false);
    const [titleFullScreenDialog, settitleFullScreenDialog] = useState("");
    const [typeFullScreenDialog, settypeFullScreenDialog] = useState("");
    const [dataMultipletax, setdataMultipletax] = useState("");
    const [openbackdrop, setopenbackdrop] = React.useState(false)

    useEffect(() => {
        componentdidmount()
    }, [])

    useEffect(() => {
        //  console.log("recheckeddata", recheckeddata);
        if (recheckeddata.length > 0) {
            checkCSardeposituse()
        }
    }, [recheckeddata])

    const checkCSardeposituse = async () => {
        let url = genURL(`/csardeposituse/Search/${from}/${recheckeddata[0].DOCNO}?`)

        let rs = await axios.get(url, { timeout: 12000 })

        await console.log("recheckeddata genURL(url)", rs);
        if (rs.data.length > 0) {
            console.log("recheckeddata", rs.data);
            let element = []
            for (let index = 0; index < rs.data.length; index++) {
                // let incometypename = await loadincometypenameData(rs.data[index].INCOMETYPE).then(rs => {
                //     return rs
                // })

                element.push({
                    id: Number(index) + 1,
                    DEPOSITNO: rs.data[index].DEPOSITNO,
                    DEBTAMOUNT: rs.data[index].PAYAMOUNT,
                    DEBTBALANCE: rs.data[index].DEBTBALANCE,
                    NOVAT: rs.data[index].BATHDEPOPAY1,
                    EXCHANGERATE: rs.data[index].DEPOSITRATE

                })
            }

            await setListitem(element)
        } else {
            await setListitem([])
        }
        await setopenbackdrop(false)
    }
    const componentdidmount = () => {
        console.log(parm);
        if (parm.tbCsardeposit) {
            setListitem(parm.tbCsardeposit)
        }
    }
    const sendData = (e) => {
        let res = false
        if (e === true) {
            res = true
        }
        let resdatas = []
        resdatas.push(res)
        // resdatas.push("Csardeposit") //ส่งกลับเพื่อเป็นเงือนไขที่มา
        resdatas.push(listitem)
        props.resdata(resdatas)
    }
    const CloseDialog = (e) => {
        setopenFullScreenDialog(e)
    }
    const ReturnData = (e) => {
        var row = listitem
        var j = listitem.length
        if (e) {
            for (let i = 0; i < e[2].length; i++) {
                row[j] = e[2][i]
                checktotalvat(j, e[2][i].DEBTBALANCE)
                checkpayamount(j)
                j++
            }
        }
        console.log("row e", e);
        setListitem(row)
        setTimeout(() => {
            sendData(true)
        }, 500);
        CloseDialog(e[0])

    }
    const SelAPDepositUse = async (e) => {
        console.log(parm.ARCode);
        var docno = ""
        console.log(listitem);
        for (let i = 0; i < listitem.length && listitem[i].DEPOSITNO; i++) {
            docno += await listitem[i].DEPOSITNO + "|"
        }
        console.log(docno);
        let arrforparm = []
        arrforparm = {
            ARCode: await parm.ARCode,
            docno: await docno,
            taxtype: await parm.taxtype
        }
        setdataMultipletax(await arrforparm)
        setopenFullScreenDialog(true)
        settitleFullScreenDialog("ค้นหาใบจ่ายเงินมัดจำ-SelARDepositUse")
        settypeFullScreenDialog(e)

    }
    const onAfterSaveCell = async (row, cellName, cellValue, e) => {
        if (cellName === "PAYAMOUNT" && cellValue) {
            if (Number(cellValue) > Number(row.DEBTBALANCE)) {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("ยอดชำระมากกว่ายอดคงเหลือ")
                row.PAYAMOUNT = row.DEBTBALANCE
                checktotalvat(e.rowIndex, row.DEBTBALANCE)
            } else {
                checktotalvat(e.rowIndex, cellValue)
            }
        }
    }
    const checktotalvat = (i, value) => {
        let sum = (Number(listitem[i].DEBTBALANCE) / (100 + Number(listitem[i].TAXRATE))) * Number(listitem[i].TAXRATE)
        let sum1 = Number(listitem[i].DEBTBALANCE) - sum
        listitem[i].NOVAT = parseFloat(sum1).toFixed(2)
    }

    const checkpayamount = (i) => {
        // let sum = (Number(listitem[i].DEBTBALANCE) / (100 + Number(listitem[i].TAXRATE))) * Number(listitem[i].TAXRATE)
        // let sum1 = Number(listitem[i].DEBTBALANCE) - sum
        listitem[i].PAYAMOUNT = parseFloat(listitem[i].DEBTBALANCE).toFixed(2)
    }
    const indexN = (cell, row, enumObject, index) => {
        return (<div>{index + 1}</div>)
    }
    return (
        <div className="panel-body DivTable">
            {/* <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} type={typeFullScreenDialog} parm={dataMultipletax}
                closeDialog={e => CloseDialog(e)}
                resData={e => ReturnData(e)}
            /> */}
            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} closeDialog={e => CloseDialog(e)}>
                {typeFullScreenDialog === "SelARDepositUse" ? <PopupCsardeposit parm={dataMultipletax} resdata={e => ReturnData(e)} /> : null}
            </FullScreenDialog>
            <button onClick={sendData}>ตกลง</button>
            <br></br>
            <BootstrapTable
                data={listitem}
                options={{
                    onRowDoubleClick: sendData,
                    noDataText: "ไม่พบข้อมูล"
                }}
                height='650'
                cellEdit={{
                    mode: "click",
                    blurToSave: true,
                    afterSaveCell: onAfterSaveCell,
                }}
            >
                <TableHeaderColumn dataAlign="center" width="30" dataField="any" dataFormat={indexN} ></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='DEPOSITNO' dataAlign="center" editable={false} isKey> ใบรับเงินมัดจำ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='DEBTBALANCE' dataAlign="left" editable={false}> คงเหลือ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='PAYAMOUNT' dataAlign="left" editable={true}> ยอดชำระ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='NOVAT' dataAlign="left" editable={false}> ไม่รวมvat </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='EXCHANGERATE' dataAlign="left" editable={false}> อัตราแลกเปลี่ยนเดิม </TableHeaderColumn>
            </BootstrapTable>
            <br></br><br></br>
            <Grid container spacing={3} direction="row">
                <Grid item xs={4}>
                </Grid>
                <Grid container xs={4} spacing={3} direction="row">
                    <Grid item xs={6}>
                        <Button style={{ height: '70%' }} onClick={() => SelAPDepositUse("SelARDepositUse")} variant="contained">เลือกเอกสาร</Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button style={{ height: '70%' }} onClick={() => sendData()} variant="contained">ตกลง</Button>
                    </Grid>
                </Grid>
                <Grid item xs={4}>
                </Grid>
            </Grid>
            <Snackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setopensnackbar(false) }}
                close />
            <CustomBackdrop open={openbackdrop} />
        </div>)
}
Csardeposit.prototype = {
    parm: PropTypes.array,
    recheckeddata: PropTypes.array,
    from: PropTypes.string
}
